@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  singlecolorgrey: $theme-filter-icon-color;
  singlecolorpurple: $theme-dropdown-checked-icon-color
}

/* stylelint-enable */

@keyframes spinner-line-fade-quick {

  0%,
  39%,
  100% {
    opacity: 0.25;
    /* minimum opacity */
  }

  40% {
    opacity: 1;
  }
}